module.exports = __webpack_public_path__ + "static/media/FHA_Home_Loans.0ea211c9.png";